<template>
  <router-view></router-view>
</template>

<script>
export default {
	name: 'tiposQuestao',
	title: 'Tipos de questões'
}
</script>

<style scoped>
</style>
